(() => {
  const selector = '[data-product-showcase]';

  function init(root) {
    if (!root || root.dataset.productShowcaseReady === 'true') return;
    root.dataset.productShowcaseReady = 'true';

    const form = root.querySelector('.hsw5-pdp__product-form');
    const productData = root.querySelector('[data-product-json]');
    const productImageData = root.querySelector('[data-product-showcase-images]');
    const testProductData = root.querySelector('[data-product-showcase-test-json]');
    const testProductImageData = root.querySelector('[data-product-showcase-test-images]');
    const sizeGuide = root.querySelector('[data-hsw5-size-guide-dialog]');
    const sizeGuideOverlay = root.querySelector('[data-hsw5-size-guide-overlay]');
    const addOnData = form?.querySelector('[data-product-add-ons]');
    const gift = root.querySelector('[data-product-showcase-gift]');
    let returnFocus = null;
    let previousOverflow = '';

    const getHsw5TestVariant = () => window.ABTestHandler?.getVariant?.('hsw5') || '';

    let configuredAddOnIds = [];
    try {
      const parsedAddOnIds = addOnData ? JSON.parse(addOnData.textContent) : [];
      if (Array.isArray(parsedAddOnIds)) configuredAddOnIds = parsedAddOnIds;
    } catch (error) {
      console.error('Product showcase add-on data could not be parsed.', error);
    }

    function syncHsw5AddOns(testVariant = getHsw5TestVariant()) {
      if (root.dataset.productHandle !== 'health-smartwatch-5') return;

      const normalizedVariant = String(testVariant || '').trim().toLowerCase();
      const recognizedVariants = ['', 'control', 'test-with-dock', 'watch-only', 'test-watch-only'];
      if (!recognizedVariants.includes(normalizedVariant)) {
        console.warn(`Unknown HSW5 test variant: ${testVariant}`);
        return;
      }
      const isWatchOnly = normalizedVariant === 'watch-only' || normalizedVariant === 'test-watch-only';
      const selectedAddOnIds = isWatchOnly ? [] : configuredAddOnIds;

      if (addOnData) addOnData.textContent = JSON.stringify(selectedAddOnIds);
      root.dataset.hsw5TestVariant = normalizedVariant || 'control';
      root.dataset.hsw5AddOnIncluded = String(selectedAddOnIds.length > 0);
      if (gift) gift.hidden = isWatchOnly;
    }

    function openSizeGuide() {
      if (!sizeGuide || !sizeGuideOverlay) return;
      returnFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      sizeGuide.hidden = false;
      sizeGuideOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
      sizeGuide.focus({ preventScroll: true });
    }

    function closeSizeGuide() {
      if (!sizeGuide || sizeGuide.hidden) return;
      sizeGuide.hidden = true;
      sizeGuideOverlay.hidden = true;
      document.body.style.overflow = previousOverflow;
      if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
    }

    root.querySelectorAll('[data-hsw5-size-guide]').forEach((button) => button.addEventListener('click', openSizeGuide));
    root.querySelectorAll('[data-hsw5-size-guide-close]').forEach((button) => button.addEventListener('click', closeSizeGuide));
    sizeGuideOverlay?.addEventListener('click', closeSizeGuide);
    sizeGuide?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSizeGuide();
      if (event.key !== 'Tab') return;
      const controls = Array.from(sizeGuide.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter((control) => !control.disabled && !control.hidden);
      if (!controls.length) return;
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (!form || !productData) return;
    let primaryProduct;
    try { primaryProduct = JSON.parse(productData.textContent); } catch (error) { console.error('Product focus data could not be parsed.', error); return; }
    let primaryVariantImages = {};
    try { primaryVariantImages = productImageData ? JSON.parse(productImageData.textContent) : {}; } catch (error) { console.error('Product showcase images could not be parsed.', error); }
    let testProduct = null;
    let testVariantImages = {};
    try { testProduct = testProductData ? JSON.parse(testProductData.textContent) : null; } catch (error) { console.error('Product showcase test product data could not be parsed.', error); }
    try { testVariantImages = testProductImageData ? JSON.parse(testProductImageData.textContent) : {}; } catch (error) { console.error('Product showcase test images could not be parsed.', error); }

    let product = primaryProduct;
    let variants = primaryProduct.variants || [];
    let variantImages = primaryVariantImages;
    if (!variants.length) return;

    const groups = Array.from(form.querySelectorAll('[data-hsw5-option-position]'));
    const variantInput = form.querySelector('[data-hsw5-variant-id]');
    const atc = form.querySelector('[data-hsw5-atc]');
    const atcText = atc?.querySelector('[data-button-text]');
    const price = root.querySelector('[data-hsw5-price]');
    const comparePrice = root.querySelector('[data-hsw5-compare-price]');
    const focusImage = root.querySelector('.product-showcase__media img');
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
    const selectedOptions = () => groups.map((group) => group.querySelector('input:checked')?.value || '');
    const exactVariant = (options) => variants.find((variant) => variant.options.every((value, index) => value === options[index]));

    function bestVariant(changedInput) {
      const wanted = selectedOptions();
      const exact = exactVariant(wanted);
      if (exact) return exact;
      const group = changedInput.closest('[data-hsw5-option-position]');
      const changedIndex = Number(group.dataset.hsw5OptionPosition) - 1;
      return variants
        .filter((variant) => variant.options[changedIndex] === changedInput.value)
        .sort((a, b) => {
          const score = (variant) => variant.options.reduce((total, value, index) => total + (value === wanted[index] ? 1 : 0), 0) + (variant.available ? 0.25 : 0);
          return score(b) - score(a);
        })[0] || variants[0];
    }

    function setCheckedOptions(variant) {
      groups.forEach((group, index) => {
        const input = Array.from(group.querySelectorAll('[data-hsw5-option-value]')).find((candidate) => candidate.value === variant.options[index]);
        if (input) input.checked = true;
      });
    }

    function updateOptionStates() {
      const current = selectedOptions();
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('label').forEach((label) => {
          const input = label.querySelector('[data-hsw5-option-value]');
          const candidates = variants.filter((variant) => variant.options.every((value, index) => index === groupIndex ? value === input.value : value === current[index]));
          const possible = candidates.length > 0;
          const soldOut = possible && !candidates.some((variant) => variant.available);
          label.classList.toggle('is-constrained', !possible);
          label.classList.toggle('is-sold-out', soldOut);
          input.setAttribute('aria-disabled', String(!possible));
          const availability = label.querySelector('[data-option-availability]');
          if (availability) availability.hidden = !soldOut;
        });
      });
    }

    function updateImage(variant) {
      if (!focusImage) return;
      const selectedColor = variant.options.find((value) => /black|rose gold/i.test(value)) || '';
      const fallbackImage = /rose gold/i.test(selectedColor) ? root.dataset.fallbackRoseGold : root.dataset.fallbackBlack;
      const mappedImage = variantImages[String(variant.id)] || {};
      const image = mappedImage.src || variant.featured_image?.src || variant.featured_image || variant.featured_media?.preview_image?.src || fallbackImage;
      if (!image) return;
      if (mappedImage.srcset) focusImage.srcset = mappedImage.srcset;
      else focusImage.removeAttribute('srcset');
      focusImage.src = image;
      focusImage.alt = `${product.title} — ${variant.options.join(' / ')}`;
    }

    function renderVariant(variant) {
      if (!variant) return;
      setCheckedOptions(variant);
      variantInput.value = variant.id;
      const variantPrice = Number(variant.price) || 0;
      const compare = Number(variant.compare_at_price) || 0;
      const hasSaving = compare > variantPrice;
      if (price) price.textContent = money(variantPrice);
      if (comparePrice) {
        comparePrice.textContent = hasSaving ? money(compare) : '';
        comparePrice.hidden = !hasSaving;
      }
      atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? atc.dataset.defaultLabel : 'Sold out';
      updateOptionStates();
      updateImage(variant);
      root.dispatchEvent(new CustomEvent('hsw5:variant-change', { bubbles: true, detail: { variant } }));
    }

    function syncHsw5Experiment(testVariant = getHsw5TestVariant()) {
      if (root.dataset.productHandle !== 'health-smartwatch-5') return false;

      const normalizedVariant = String(testVariant || '').trim().toLowerCase();
      const recognizedVariants = ['', 'control', 'test-with-dock', 'watch-only', 'test-watch-only'];
      if (!recognizedVariants.includes(normalizedVariant)) {
        console.warn(`Unknown HSW5 test variant: ${testVariant}`);
        return false;
      }

      const useTestProduct = normalizedVariant !== '' && normalizedVariant !== 'control' && Boolean(testProduct);
      const wantedOptions = selectedOptions();
      product = useTestProduct ? testProduct : primaryProduct;
      variants = product.variants || [];
      variantImages = useTestProduct ? testVariantImages : primaryVariantImages;

      if (!variants.length) return false;
      const matchingVariant = exactVariant(wantedOptions)
        || variants.find((variant) => variant.available)
        || variants[0];

      syncHsw5AddOns(normalizedVariant);
      root.dataset.hsw5ActiveTestProduct = useTestProduct ? 'test' : 'primary';
      renderVariant(matchingVariant);
      return true;
    }

    form.addEventListener('change', (event) => {
      if (!event.target.matches('[data-hsw5-option-value]')) return;
      renderVariant(bestVariant(event.target));
    });

    window.addEventListener('abtest:variant-changed', (event) => {
      if (event.detail?.experiment !== 'hsw5') return;
      syncHsw5Experiment(event.detail?.trigger);
    });

    if (!syncHsw5Experiment()) {
      renderVariant(variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants.find((variant) => variant.available) || variants[0]);
    }
  }

  const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
